import { DatePipe } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';

@Component({
  selector: 'app-anybodypart',
  templateUrl: './anybodypart.component.html',
  styleUrls: ['./anybodypart.component.css']
})
export class AnybodypartComponent extends FormSessionCanDeactivate {
  bodysurgical: any[];
  f22: any;
  payortypechange: any = [];
  tss: any;
  payor: any;
  plan: any;
  newplan: any;
  shospital7: boolean;
  payortype: any;
  fracture: boolean = false;
  showinvaild: boolean;
  enablepage: boolean = false
  showloader: boolean = false;
  enableaddBody: boolean = true;
  merge: any;
  show: boolean;
  shospital6: boolean;
  CurrentUser: User;
  modalRef: BsModalRef;
  public bobMaxDate = new Date();
  public dosMaxDate = new Date(this.bobMaxDate.getTime())
  public name: any;
  public object: any;
  public datenew = new Date("01/01/1800");
  temp_var: any;
  addpart: any;
  addid: any;
  temp = false;
  canAddBodypart: boolean = true;
  public tembodyPart: any;
  public hiddenchecked: boolean = false;
  public showcross: boolean = false;
  //default add body value
  public defaultBodyDetails: any = {
    carePath: '',
    bodyPartStatus: 'False',
    laterality: '',
    hospitalId: '',
    surgeonId: '',
    dos: '',
    mako: '',
    cjr: '',
    merge: false,
    fracture: '',
    payorType: '',
    hic: '',
    dischargeDate: '',
    dischargeLoc: '',
    facilityPhone: '',
    facilityContact: '',
    dischargeWith: '',
    dischargeTo: '',
    bpci: '',
    payorId: '',
    plan: '',
    tss: ''
  }
  public bodyPartDetails: any = {
    dosStatus: 'notSelected',
    bodyLocation: '',
    bodyprocedure: '',
    other: '',
    bodyPart: '',
    bodySide: '',
    surgeonId: '',
    payorType: '',
    mako: '',
    cjr: '',
    merge: false,
    fracture: '',
    hospitalId: '',
    dischargeWith: '',
    dischargeLoc: '',
    dischargeId: '',
    dischargeHospitalMasterId: '',
    dischargeTo: '',
    payorId: '',
    skipcommercial: false,
    plan: '',
    tss: '',
    disqualifi: {}
  };
  public bodyParts = [];
  public bodyside: any;
  public bodyloc: any;
  public surgeonList = [];
  public snfList = [];
  public hospitalList = [];
  public surgeonUserNames = [];
  public dosStatus = 'notSelected';
  //upper body option
  public dateformat = environment.dateFormat;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  public upperBodypartOption: any = [{
    'value': "Neck-Neck",
    'name': 'Neck'
  }, {
    'value': "Back-Back",
    'name': 'Back'
  }, {
    'value': 'Neck-Back',
    'name': 'Neck & Back'
  }, {
    'value': 'Shoulder-Left',
    'name': 'Shoulder - Left'
  }, {
    'value': 'Shoulder-Right',
    'name': 'Shoulder - Right'
  }, {
    'value': 'Elbow-Left',
    'name': 'Elbow - Left'
  }, {
    'value': 'Elbow-Right',
    'name': 'Elbow - Right'
  }, {
    'value': 'Hand-Left',
    'name': 'Hand - Left'
  }, {
    'value': 'Hand-Right',
    'name': 'Hand - Right'
  },
  {
    'value': 'Wrist-Left',
    'name': 'Wrist - Left'
  }, {
    'value': 'Wrist-Right',
    'name': 'Wrist - Right'
  }, {
    'value': 'Arm-Left',
    'name': 'Arm - Left'
  }, {
    'value': 'Arm-Right',
    'name': 'Arm - Right'
  }, {
    'value': 'Fore Arm-Left',
    'name': 'Fore Arm - Left'
  }, {
    'value': 'Fore Arm-Right',
    'name': 'Fore Arm - Right'
  }
  ]
  //lower body option
  public lowerBodypartOption: any = [{
    'value': "Total Hip Replacement-Left",
    'name': 'Total Hip - Left'
  }, {
    'value': "Total Hip Replacement-Right",
    'name': 'Total Hip - Right'
  }, {
    'value': 'Total Hip Replacement-Bilateral',
    'name': 'Total Hip - Bilateral'
  }, {
    'value': 'Total Knee Replacement-Left',
    'name': 'Total Knee - Left'
  }, {
    'value': 'Total Knee Replacement-Right',
    'name': 'Total Knee - Right'
  }, {
    'value': 'Total Knee Replacement-Bilateral',
    'name': 'Total Knee - Bilateral'
  }, {
    'value': 'Partial Knee Replacement-Left',
    'name': 'Partial Knee - Left'
  }, {
    'value': 'Partial Knee Replacement-Right',
    'name': 'Partial Knee - Right'
  }, {
    'value': 'Partial Knee Replacement-Bilateral',
    'name': 'Partial Knee - Bilateral'
  },
  {
    'value': 'Sports Knee-Left',
    'name': 'Knee Sports - Left'
  }, {
    'value': 'Sports Knee-Right',
    'name': 'Knee Sports - Right'
  }, {
    'value': 'Sports Hip-Left',
    'name': 'Hip Sports - Left'
  }, {
    'value': 'Sports Hip-Right',
    'name': 'Hip Sports - Right'
  }, {
    'value': 'Foot-Left',
    'name': 'Foot - Left'
  }, {
    'value': 'Foot-Right',
    'name': 'Foot - Right'
  }, {
    'value': 'Ankle-Left',
    'name': 'Ankle - Left'
  }, {
    'value': 'Ankle-Right',
    'name': 'Ankle - Right'
  }
  ]
  //base url
  apiurl: any = environment.api_url;
  public timealert = environment.timelimit;
  public data: Object;
  public params: any;
  public stageArray: any = [];
  public showTable = false;
  public materialsArray: any = [];
  public mindos: any;
  clienttype: string;
  bodytype: boolean;
  partbody: any;
  sidepart: any;
  partsurgeon: any;
  public imageURL: string = environment.cloudeImageURL;
  constructor(
    private userService: UserService,
    private route: Router,
    private router: ActivatedRoute,
    private patientService: PatientService,
    private datepipe: DatePipe, private toast: ToastrService,
    private modalService: BsModalService, private localeService: BsLocaleService
  ) {
    super();
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    // //////console.log("care family")
    this.userService.tempVar.subscribe(
      (data) => {
        if (data) {
          this.params = data
        } else {
          if (this.bodyPartDetails.payorType == 1 && !this.bodyPartDetails.skipcommercial && this.CurrentUser.item.commercialType && this.CurrentUser.item.userrole == 'Commercial Care Navigator') {
            this.route.navigate(['/care/patientqualification'],)
          } else {
            this.route.navigate(['/care/patientlist'])
          }
        }
      })
  }

  ngOnInit() {
    this.dosMaxDate.setDate(this.dosMaxDate.getUTCDate() + 365);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        if (this.CurrentUser.item) {
          //window.localStorage['patientId'] = this.params.name;
          if (window.localStorage['patSwfId']) {
            window.localStorage.removeItem('patSwfId')
          }
          if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.CurrentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
        //this.hospitalid = 100317;
      }
    )



    this.clienttype = this.CurrentUser.item.clientType;
    ////console.log("type",this.clienttype)
    let self = this;

    //get patient basic details
    this.patientService
      .getuserid(this.params.name)
      .subscribe(
        data => {
          this.temp_var = true;
          if (Array.isArray(data) && data.length) {

            this.mindos = new Date(data[0].Dob)
            //this.getAddedBodyPart(data[0]['allServiceLineLabel'])
            this.bodyPartDetails.payorType = data[0].PayorType
            this.bodyPartDetails.payorId = data[0].payorName
            this.bodyPartDetails.plan = data[0].plans
            this.bodyPartDetails.tss = data[0].TSS
            this.bodyPartDetails.payorId = data[0].payorId
            if (data[0].payorId == 4) {
              this.bodyPartDetails.payorId = 0
            }
            if (data[0].PayorType == 1 && this.CurrentUser.item.commercialType) {
              //this.mindos = new Date()
              data[0].PayorType = 'Commercial'
              if (this.CurrentUser.item.commercialType && this.bodyPartDetails.payorId != 0) {
                this.getbundlepayortypeprocedure(this.bodyPartDetails.payorId)
              } else {
                this.patientService.getSurgicalLocation(this.CurrentUser.item.userAccountKey, 0).subscribe(data => {
                  this.bodysurgical = data
                })
              }
            }
            else if (data[0].PayorType == 2)
              data[0].PayorType = 'Medicare'
            else if (data[0].PayorType == 3)
              data[0].PayorType = 'Medicare Advantage'
            else if (data[0].PayorType == 4)
              data[0].PayorType = 'Medicaid'
            else if (data[0].PayorType == 5)
              data[0].PayorType = 'Other'
            this.addpart = data;
            this.payor = data[0]
            if (data[0].PayorType != 'Commercial' || !this.CurrentUser.item.commercialType) {
              this.bodysurgical = []
              this.bodyPartDetails.dos = ''
              this.bodyPartDetails.hospitalId = ''
              this.bodyPartDetails.bodyLocation = '';
              this.bodyPartDetails.bodyPart = ''
              this.bodyPartDetails.bodySide = ''
              this.patientService.getSurgicalLocation(this.CurrentUser.item.userAccountKey, 0).subscribe(data => {
                this.bodysurgical = data
              })
            }
            //console.log("data",this.addpart[0].PayorType == 1)
          }

        }
      );
    self.getBodyPart();
    self.getSurgeonNames();
    self.getHospitalLsit();
    self.getSnfNames();
    self.getfacilitylist()
    self.getbundlepayortype();
    self.enablepage = true
  }
  //get list of added body parts to patient
  /**
   * 
   * @param service string value of added bodyparts
   */

  getBodyPart() {
    let self = this;
    self.patientService.getBodyLocation(this.CurrentUser.item.userAccountKey)
      .subscribe(data => {
        self.bodyloc = data
      })

  }
  getSurgicalLocation(event) {
    if (event) {
      this.bodyPartDetails.plan = ''
      this.bodyPartDetails.tss = ''
      this.bodyPartDetails.commercialPayorType = ''
      this.bodyPartDetails.payorId = ''
      this.patientService.getSurgicalLocation(this.CurrentUser.item.userAccountKey, 0).subscribe(data => {
        this.bodysurgical = data
      })
      this.getHospitalLsit()
    }


  }

  //filter body parts options 
  /**
   * 
   * @param data alreay added bodyparts array
   */
  filterbodyOption(data) {
    let self = this;
    let temdataupper = _.reject(self.upperBodypartOption, (o) => {
      return data.includes(o.value.replace(/ /g, ''))
    })
    let temdalower = _.reject(self.lowerBodypartOption, (o) => {
      return data.includes(o.value.replace(/ /g, ''))
    })
    self.upperBodypartOption = temdataupper;
    self.lowerBodypartOption = temdalower;
  }
  //Get surgeon list for the drop down select surgeon
  getSurgeonNames() {
    let self = this;
    self.patientService.getSurgeonlist(self.CurrentUser.item.userAccountId)
      .subscribe(data => {
        self.surgeonList = data
      })
  }
  //Get option list for the snf names drop down
  getSnfNames() {
    let self = this;
    self.patientService.getSnfList()
      .subscribe(data => {
        self.snfList = data.aaData[0].dischargehospitalList
      })
  }


  //get options for facilityList names
  facilityList: any;
  getfacilitylist() {
    let self = this;
    self.patientService.getFacilityList(this.CurrentUser.item.userAccountKey)
      .subscribe(data => {
        self.facilityList = data
      })
  }
  //change dos status
  /**
   * 
   * @param event dos value
   */
  dateofdob: boolean = false
  findPastorFutureDate(dos, argDate) {
    argDate = new Date(argDate);
    dos = new Date(dos);
    ////console.log('argDate'+argDate) 
    ////console.log('dos'+dos) 
    if (argDate < dos)
      return true;

    return false;
  }
  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.CurrentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }
  onDateValueChange(showmerge: TemplateRef<any>, bodypart, side, event) {
    //////console.log("herere")
    let self = this;
    let date = this.datepipe.transform(event, 'yyyy-MM-dd');
    if (date) {
      let toDate = new Date();
      let bDos = new Date(date);
      bDos.setDate(bDos.getDate() + 1)
      var dobDiff = this.findPastorFutureDate(this.changeFormatToDate(this.mindos), this.changeFormatToDate(event));
      if (dobDiff) {
        this.dateofdob = true
        this.bodyPartDetails.dos = null
        return;
      }
      else {
        this.dateofdob = false
      }
      // else if (dob > bDos.getTime() && this.CurrentUser.item.commercialType && this.bodyPartDetails.payorType == '1') {
      //   self.toast.error('Date of Surgery should not be Past ', '', {
      //     timeOut: this.timealert
      //   });
      //   return;
      // }
      toDate.setDate(toDate.getDate() - 1);
      let Dos = new Date(date);
      if (toDate.getTime() <= Dos.getTime()) {
        self.dosStatus = "future"
      }
      if (toDate.getTime() > Dos.getTime()) {
        self.dosStatus = "past"
      }
      if (bodypart && side) {
        let f2 = this.addpart[0].allServiceLineLabel.split(',')
        let merge = false
        self.f22 = 0
        for (let i = 0; i < f2.length; i++) {
          let te;
          if (bodypart == 'Hip and Femur Fracture (SHFFT)' && f2[i].includes('Hip and Femur Fracture (SHFFT)')) {
            f2[i] = f2[i].replace('(SHFFT)', "")
          }
          te = f2[i].split('(');
          te[1] = te[1].replace(')', "")
          te[1] = te[1].replace(/\s/g, "");
          te[0] = te[0].replace(/\s/g, "");
          f2[i] = te
          if (bodypart.replace(/\s/g, "") == te[0] || te[0] == 'HipandFemurFracture') {
            if (bodypart == 'Total Knee Replacement' || bodypart == 'Partial Knee Replacement' || bodypart == 'Revision Hip Replacement' || bodypart == 'Total Hip Replacement' || bodypart == 'Partial Hip Replacement' || bodypart == 'Hip and Femur Fracture (SHFFT)' || bodypart == 'Revision Knee Replacement') {
              self.patientService.getbilateral(this.params.name, bodypart, side, date)
                .subscribe(data => {
                  if (data) {
                    this.getmodal(data, showmerge)
                  }
                })
            }

          }


        }


      }
    }
  }
  getmodal(merge, showmerge) {
    let self = this
    if (merge && self.f22 == 0) {
      self.modalRef = self.modalService.show(showmerge, { class: 'modal-sm', backdrop: 'static' })
      this.movable()
      self.f22++;
    }
  }
  addmerge() {
    this.bodyPartDetails.merge = true
    this.modalRef.hide()
  }
  //Get hospital list for drop down select hospital
  getHospitalLsit() {
    let self = this;
    self.patientService.getHospitalList(self.CurrentUser.item.userAccountId)
      .subscribe(data => {
        self.hospitalList = _.filter(data.aaData, (o) => {
          return o.hospitalId != 10001
        })
      })
  }
  //get bodypart option based on body location
  /**
   * 
   * @param event selected boay location value
   */
  getBodyParts(event) {
    this.partbody = event
    ////console.log("event",event)
    let f2 = this.addpart[0].allServiceLineLabel.split(',')
    if (event == this.userService.translateText('hospital_portal.body_part.neck.label') || event == this.userService.translateText('hospital_portal.body_part.back.label')) {
      this.show = false
    }
    else {
      this.show = true
    }

    for (let i = 0; i < f2.length; i++) {
      if (f2[i].includes('Hip and Femur Fracture (SHFFT)')) {
        f2[i] = f2[i].replace('(SHFFT)', "")
      }
      let te = f2[i].split('(');
      te[1] = te[1].replace(')', "")
      te[1] = te[1].replace(/\s/g, "");
      te[0] = te[0].replace(/\s/g, "");
      f2[i] = te

      if (te[1] == 'Bilateral') {
        this.temp = false

        if (te[0] == 'HipandFemurFracture') {
          this.bodyloc.ServicelineLabel = _.reject(this.bodyloc.ServicelineLabel, (o: any): any => {
            return o.ServicelineLabel.replace(/\s/g, "") == 'HipandFemurFracture(SHFFT)';
          })
        }
        else {
          this.bodyloc.ServicelineLabel = _.reject(this.bodyloc.ServicelineLabel, (o: any): any => {
            return (o.ServicelineLabel.replace(/\s/g, "") == te[0]) && (o.SurgicalLocation == te[1]);
          })
        }

      }
      else if (te[1] == this.userService.translateText('hospital_portal.body_part.neck.label') || te[1] == this.userService.translateText('hospital_portal.body_part.back.label')) {
        this.temp = false
        this.bodyloc.ServicelineLabel = _.reject(this.bodyloc.ServicelineLabel, (o: any): any => {
          return (o.ServicelineLabel.replace(/\s/g, "") == te[0]) && (o.SurgicalLocation == te[1]);
        })

      }
    }
    if (event == this.userService.translateText('hospital_portal.body_part.neck.label') || event == this.userService.translateText('hospital_portal.body_part.back.label')) {
      this.show = false
    }
    else {
      this.show = true
    }
    if (event == this.userService.translateText('hospital_portal.body_part.shoulder.label')) {
      ////console.log(event)
      this.bodytype = true
    }
    else {
      this.bodytype = false;

    }
    if (event == this.userService.translateText('hospital_portal.body_part.extremidad_superior.label'))
      this.bodyPartDetails.mako = ''
  }
  getbundlepayortypeprocedure(id) {
    let self = this;
    self.patientService.getBundlepartType(this.CurrentUser.item.userAccountKey, id)
      .subscribe(data => {
        this.bodysurgical = []
        this.bodyPartDetails.dos = ''
        this.bodyPartDetails.hospitalId = ''
        this.bodyPartDetails.surgeonId = ''
        this.bodyPartDetails.bodyLocation = '';
        this.bodyPartDetails.bodyPart = ''
        this.bodyPartDetails.bodySide = ''
        this.payortypechange = data
        ////console.log(this.payortypechange)
        this.patientService.getSurgicalLocation(this.CurrentUser.item.userAccountKey, id).subscribe(data => {
          this.bodysurgical = data
        })
        this.getHospitalListbyPayor(this.bodyPartDetails.payorId, 0)
        //////console.log(this.bodylocation.ServicelineLabel)
      })
  }


  getHospitalListbyPayor(payorId, surgeonId) {
    this.patientService.getHospitalListbyPayor(payorId, this.CurrentUser.item.userAccountKey, surgeonId).subscribe(data => {
      this.hospitalList = _.filter(data, (o) => {
        return o.hospitalId != 500000
      })
    })
  }
  //get surgeon user name using surgeon id
  /**
   * 
   * @param event surgeon id
   */
  selecthosp: any = [];
  formSurgeonIdChange(bodyPart, bodySide, event) {
    let self = this;
    let temArray, temArray1 = []
    self.bodyPartDetails.hospitalId = ""
    if (this.CurrentUser.item.commercialType && this.bodyPartDetails.payorId) {
      let surgeonId = this.bodyPartDetails.surgeonId ? this.bodyPartDetails.surgeonId : 0
      this.getHospitalListbyPayor(this.bodyPartDetails.payorId, surgeonId)
    }
    temArray = _.filter(self.surgeonList, (n) => {
      return n.surgeonId == event
    })

    if (this.hospitalList) {
      temArray1 = _.filter(this.hospitalList, (n) => {
        return (n.name.match('Unknown') || n.name.match('Other'))
      })
      temArray1 = temArray1.map(function (el) { return el.hospitalId; });
    }

    self.selecthosp = JSON.parse(temArray[0].hospitalList)
    if (temArray1.length > 0 && self.selecthosp.length > 0) {
      self.selecthosp = self.selecthosp.concat(temArray1)
    }
    self.surgeonUserNames = temArray
    self.checkServiceAvailablity(bodyPart, bodySide, event)
  }
  //check select serviceline is available for that particular login
  /**
   * 
   * @param event select service line value
   */
  checkServiceAvailablity(bodylocation, event, surgid) {
    this.sidepart = event;
    this.partsurgeon = surgid;
    let self = this;
    // self.removeOption(event,index)
    if (event != '' && bodylocation && surgid) {
      self.getBodyPartServiceAvailable(bodylocation, event, surgid)
    }
    else
      if (bodylocation == 'Lumbar Fusion' || bodylocation == 'Lumbar Laminectomy' || bodylocation == 'Cervical Fusion' || bodylocation == 'Cervical Laminectomy' || bodylocation == 'T-Spine' || (bodylocation == 'Other.' && (this.bodyPartDetails.bodyLocation == 'Neck' || this.bodyPartDetails.bodyLocation == 'Back'))) {
        if (bodylocation && this.partbody && this.partsurgeon) {
          self.getBodyPartServiceAvailable(bodylocation, this.partbody, this.partsurgeon)
        }
      }
  }
  //add body part to patient
  addBody() {
    let self = this;
    self.showloader = true;
    self.enableaddBody = false;
    self.arrangreData().then(
      (data: any) => {
        data.patientId = self.params.name;
        self.patientService.addSinglePart(data, this.CurrentUser.item.userAccountId, this.bodyPartDetails.skipcommercial)
          .subscribe(data => {
            if (data) {
              this.enablepage = false
              self.toast.success(this.userService.translateText('hospital_portal.disp_messages.procedure_added.success'), '', {
                timeOut: this.timealert
              })
              self.userService.logAudit('configureNewBodyPart', 0).subscribe(data => { })
              if (this.bodyPartDetails.payorType == 1 && !this.bodyPartDetails.skipcommercial && this.CurrentUser.item.commercialType && this.CurrentUser.item.userrole == 'Commercial Care Navigator') {
                self.route.navigate(['/care/patientqualification'],)
              } else {
                self.route.navigate(['/care/patientlist'])
              }
              this.patientService.getcountqual('Default', this.CurrentUser.item.userAccountId, this.CurrentUser.item.selectCNUserId).subscribe(
                data => {
                  if (data)
                    this.CurrentUser.item.pqtlength = parseInt(data.Count)
                }
              )
            }
            else {
              self.toast.error(this.userService.translateText('hospital_portal.disp_messages.procedure_not_added.error'), '', {
                timeOut: this.timealert
              })
              this.ngOnInit();
              this.enableaddBody = true;
            }
            self.showloader = false;
          })
      }
    )
  }
  //get discharge with user name using id
  formdischaregeChange(event) {
    let self = this;
    if (event == 'Choose') {
      if (self.bodyPartDetails.dischargeUserName) {
        delete self.bodyPartDetails.dischargeUserName
      }
    }
    if (event != 'Choose') {
      // if(form == 'main'){
      self.getsurgeonUserName(event)
      // }
      // if(form != 'main'){
      //   self.listOfParts[form].dischargeUserName = self.getsurgeonUserName(event,)
      // }
    }
  }
  //get iuser name form the backend 
  /**
   * 
   * @param id selected dischargewith id
   */
  getsurgeonUserName(id) {
    let self = this;
    self.patientService.getSurgeonUserId(id)
      .subscribe(data => {
        self.bodyPartDetails.dischargeUserName = data.surUserAccId;
        return;
      })
  }
  //rearrange date before save it
  arrangreData() {
    let self = this;

    self.tembodyPart = Object.assign({}, self.bodyPartDetails)
    let promise = new Promise((resolve, reject) => {
      if (self.tembodyPart) {
        let bodyPart = {
          carePath: '',
          other: '',
          bodyPartStatus: 'False',
          laterality: '',
          hospitalId: '',
          dropDownSOSId: '',
          surgeonId: '',
          dos: '',
          mako: '',
          cjr: '',
          merge: false,
          fracture: '',
          payorType: '',
          hic: '',
          dischargeDate: '',
          dischargeLoc: '',
          facilityPhone: '',
          facilityContact: '',
          dischargeWith: '',
          dischargeId: '',
          dischargeHospitalMasterId: '',
          dischargeTo: '',
          bpci: '',
          commercialPayorType: '',
          plan: '',
          tss: '',
          disqualifi: {}
        }

        if (self.tembodyPart) {
          bodyPart.plan = self.tembodyPart.plan
          bodyPart.tss = self.tembodyPart.tss
          if (self.tembodyPart.payorId)
            bodyPart.commercialPayorType = self.tembodyPart.payorId
          else {
            bodyPart.commercialPayorType = '4'
          }

          bodyPart.bodyPartStatus = "True";
          if (self.tembodyPart.hasOwnProperty('bodyPart')) {
            let data = self.tembodyPart['bodyPart'].split('###');
            bodyPart.carePath = `'${data[0]}'`;
            if (data[0] == 'Lumbar Fusion' || data[0] == 'Lumbar Laminectomy' || data[0] == 'Cervical Fusion' || data[0] == 'Cervical Laminectomy' || data[0] == 'T-Spine' || (data[0] == 'Other.' && (this.bodyPartDetails.bodyLocation == 'Neck' || this.bodyPartDetails.bodyLocation == 'Back'))) {
              bodyPart.laterality = `'${self.tembodyPart['bodyprocedure']}'`;
            }
            else
              bodyPart.laterality = `'${self.tembodyPart['bodySide']}'`;
          }
          if (self.tembodyPart.hasOwnProperty('hospitalId')) {
            bodyPart.hospitalId = self.tembodyPart.hospitalId;
            bodyPart.dropDownSOSId = self.tembodyPart.hospitalId;
          }
          if (self.tembodyPart.hasOwnProperty('other')) {
            bodyPart.other = self.tembodyPart.other;
          }
          if (!bodyPart.hospitalId) {
            bodyPart.hospitalId = '100000';
            self.tembodyPart.hospitalId = '100000'
            bodyPart.dropDownSOSId = self.tembodyPart.hospitalId;
          }
          if (self.tembodyPart.hasOwnProperty('surgeonId') && self.tembodyPart.surgeonId) {
            bodyPart.surgeonId = self.tembodyPart.surgeonId;
          }
          else {
            bodyPart.surgeonId = '500000';
            self.tembodyPart.surgeonId = '500000'
          }
          if (self.tembodyPart.dos) {
            bodyPart.dos = self.datepipe.transform(self.tembodyPart.dos, 'yyyy-MM-dd')
          }
          else {
            bodyPart.dos = ''
          }
          bodyPart.mako = self.tembodyPart.mako;
          if (self.tembodyPart.hasOwnProperty('cjr')) {
            if (self.tembodyPart.cjr == "Yes" || self.tembodyPart.cjr)
              bodyPart.cjr = 'Yes';
          }
          if (self.tembodyPart.hasOwnProperty('merge')) {
            if (self.tembodyPart.merge)
              bodyPart.merge = self.tembodyPart.merge;
          }
          if (self.tembodyPart.hasOwnProperty('fracture')) {
            if ((self.tembodyPart.fracture || this.fracture) && self.tembodyPart.bodyprocedure == 'Hip')
              bodyPart.fracture = 'Yes';
            else {
              let data = self.tembodyPart['bodyPart'].split('###');
              bodyPart.carePath = `'${data[0]}'`;
              if (data[0].toUpperCase() == 'HIP AND FEMUR FRACTURE (SHFFT)' || data[0].toUpperCase() == 'PARTIAL HIP REPLACEMENT') {
                bodyPart.fracture = 'Yes';
              }
            }
          }
          if (self.tembodyPart.hasOwnProperty('payorType')) {
            //  if(self.tembodyPart.payorType == 2){
            //  bodyPart.bpci = 'Yes'
            bodyPart.bpci = self.getBpci()
            bodyPart.payorType = self.tembodyPart.payorType
          }
          if (self.tembodyPart.hasOwnProperty('hic')) {
            bodyPart.hic = self.tembodyPart.hic;
          }
          if (self.tembodyPart.hasOwnProperty('dischargeDate')) {
            bodyPart.dischargeDate = self.datepipe.transform(self.tembodyPart.dischargeDate, 'yyyy-MM-dd');
          }
          if (self.tembodyPart.hasOwnProperty('dischargeLoc')) {
            bodyPart.dischargeLoc = self.tembodyPart.dischargeLoc;
          }
          if (self.tembodyPart.hasOwnProperty('facilityPhone')) {
            bodyPart.facilityPhone = self.tembodyPart.facilityPhone;
          }
          if (self.tembodyPart.hasOwnProperty('facilityContact')) {
            bodyPart.facilityContact = self.tembodyPart.facilityContact;
          }
          if (self.tembodyPart.hasOwnProperty('dischargeUserName')) {
            bodyPart.dischargeWith = self.tembodyPart.dischargeUserName;
          }
          if (self.tembodyPart.hasOwnProperty('disqualifi') && self.tembodyPart.payorType == 1) {
            bodyPart.disqualifi = self.tembodyPart.disqualifi;
          }
          if (self.tembodyPart.hasOwnProperty('dischargeTo')) {
            if (self.tembodyPart.dischargeTo != "") {
              let index = _.findIndex(self.snfList, (o: any): any => {
                return o.dischargeHospitalMasterId == self.tembodyPart.dischargeTo
              })
              bodyPart.dischargeTo = self.snfList[index].dischargeTo;
              bodyPart.dischargeId = self.snfList[index].dischargeId;
              bodyPart.dischargeHospitalMasterId = self.snfList[index].dischargeHospitalMasterId;
            }
          }
          resolve(bodyPart);
        }
      } else {
        resolve(self.defaultBodyDetails)
      }
    });
    return promise;
  }

  //calculate bpci
  getBpci() {
    if ((this.addpart[0].PayorType == 'Medicare' && this.clienttype && this.clienttype.search("BPCIA") != -1) && (this.bodyPartDetails.bodyPart != 'Revision Knee Replacement' && this.bodyPartDetails.bodyPart != 'Revision Hip Replacement' && !this.bodyPartDetails.cjr)) {
      return 'Yes';
    }
    else {
      return 'No'
    }
  }

  /* getBpci(){
  let self = this;
  let diff_ms = Date.now() - new Date(self.addpart[0].Dob).getTime();
  let age_dt = new Date(diff_ms); 

  let age = Math.abs(age_dt.getUTCFullYear() - 1970);
  if(age >= 65){
    return 'Yes';
  }
  if(age < 65){
    return 'No'
  }
} */
  //get view worrflow episodes
  /**
   * 
   * @param template view workflow template
   * @param workflow workflowId
   */
  openViewModal(template: TemplateRef<any>, workflowId: any) {
    let self = this;
    self.patientService.getWorkflowStages(workflowId).subscribe(data => {
      self.stageArray = data
      if (data.length) {
        self.getStageDetails(data[0]['episodeId'])
      }
      this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'materialtab gray modal-lg' }));
      this.movable()
      // this.viewWorkflow= workflow
    })
  }

  //get stage Material Details array
  /**
   * 
   * @param id episode Id
   */
  getStageDetails(id) {
    let self = this;
    self.showTable = false
    self.patientService.getStagesMaterials(id).subscribe(data => {
      self.materialsArray = _.orderBy(data, ['elapsedTime'], ['desc']);
      self.showTable = true
    },
      err => {
        self.showTable = true;
      }
    )
  }

  checkfrac(bodyPart) {
    if (bodyPart.toUpperCase() == 'HIP AND FEMUR FRACTURE (SHFFT)' || (bodyPart.toUpperCase()) == 'PARTIAL HIP REPLACEMENT') {
      this.bodyPartDetails.fracture = true
      return true
    } else {
      this.bodyPartDetails.fracture = false
      return false
    }
  }

  checfrac(event, i) {
    this.bodyPartDetails.fracture = event.target.checked
    this.fracture = event.target.checked
  }

  getBodyPartServiceAvailable(bodypart, partbody, surgeonId) {
    let self = this
    self.patientService.getBodyPartServiceAvailable(bodypart, partbody, surgeonId).subscribe(data => {
      if (data.surveyStatus == 'false') {
        self.bodyPartDetails.bodyPart = ''
        self.bodyPartDetails.bodySide = ""
        self.toast.error(this.userService.translateText('hospital_portal.disp_messages.selected_service.error'), '', {
          timeOut: this.timealert
        })
      }
      if (data.surveyStatus == 'true') {
        self.bodyPartDetails.workflowId = data.viewWorkflowId;
      }
    })
  }

  //show side
  showlist(proceduretype, bodypart) {
    let self = this;
    if (environment.OpBodyPart.search(bodypart) == -1) {
      this.hospitalList = _.filter(this.hospitalList, (o: any): any => {
        return o.admissionId != 2
      })
      //console.log(JSON.stringify(this.hospitalList))
    } else if (!this.CurrentUser.item.commercialType || (this.CurrentUser.item.userrole != 'Commercial Care Navigator' && this.CurrentUser.item.userGroupId != 34)) {
      this.hospitalList = [];
      self.getHospitalLsit();
    } else {
      let surgeonId = this.bodyPartDetails.surgeonId ? this.bodyPartDetails.surgeonId : 0
      this.getHospitalListbyPayor(this.bodyPartDetails.payorId, surgeonId)
    }
    this.bodyPartDetails.bodySide = ''
    this.bodyPartDetails.other = ''
    if (bodypart != '') {
      let i = _.findIndex(this.bodyloc.ServicelineLabel, (o: any): any => {
        return (o.ServicelineLabel == bodypart && (o.SurgicalLocationDisplayName == this.bodyPartDetails.bodyLocation));
      })
      
      if (i != -1)
        this.bodyPartDetails.bodyprocedure = this.bodyloc.ServicelineLabel[i].Location
      else
        this.bodyPartDetails.bodyprocedure = 'Other'
      this.temp = true
      let f2 = this.addpart[0].allServiceLineLabel.split(',')
      let temarray = _.filter(f2, (o: any): any => {
        return o.includes(bodypart)
      })
      if (temarray.length > 1 && bodypart != 'Other') {
        this.bodyside = [];
        return;
      }
      for (let i = 0; i < f2.length; i++) {
        let te;
        if (bodypart == 'Hip and Femur Fracture (SHFFT)' && f2[i].includes('Hip and Femur Fracture (SHFFT)')) {
          f2[i] = f2[i].replace('(SHFFT)', "")
        }
        te = f2[i].split('(');
        te[1] = te[1].replace(')', "")
        te[1] = te[1].replace(/\s/g, "");
        te[0] = te[0].replace(/\s/g, "");
        f2[i] = te
        if (bodypart.replace(/\s/g, "") == te[0] || te[0] == 'HipandFemurFracture') {
          if (te[1] == 'Left') {
            this.bodyside = ['Right']
            return
          }
          else if (te[1] == 'Right') {
            this.bodyside = ['Left']
            return
          }
          else if (te[1] == 'Bilateral') {
            this.temp = false
            this.bodyside = []
            return
          }
        }

      }
      ////console.log(proceduretype)


      let self = this;
      // self.removeOption(event,index)


      if (bodypart == 'Lumbar Fusion' || bodypart == 'Lumbar Laminectomy' || bodypart == 'Cervical Fusion' || bodypart == 'Cervical Laminectomy' || bodypart == 'T-Spine' || (bodypart == 'Other.' && (this.bodyPartDetails.bodyLocation == 'Neck' || this.bodyPartDetails.bodyLocation == 'Back'))) {
        ////console.log("in")
        this.show = false
        this.partbody = this.bodyPartDetails.bodyprocedure
        if (!self.bodyPartDetails.hasOwnProperty('surgeonId')) {
          self.bodyPartDetails.surgeonId = '500000';
        }
        if (self.bodyPartDetails.surgeonId) {
          self.getBodyPartServiceAvailable(bodypart, this.partbody, self.bodyPartDetails.surgeonId)

        }
      }

      else if (bodypart && this.sidepart && this.partsurgeon) {
        this.show = true
        self.getBodyPartServiceAvailable(bodypart, self.sidepart, self.partsurgeon)
      }
      else {
        this.show = true
      }
    }
    else {
      this.temp = false

    }
    if (this.bodyPartDetails.payorType == '1' && this.CurrentUser.item.commercialType) {
      switch (proceduretype) {
        case "Hip":
          return this.bodyside = ['Left', 'Right']
        case 'T-Spine':
          this.fracture = false
          return this.bodyside = []
        default:
          this.fracture = false
          return this.bodyside = ['Left', 'Right']
      }
    } else {
      if (this.bodyPartDetails.bodyprocedure == "Hip" || this.bodyPartDetails.bodyprocedure == "Knee") {
        this.bodyside = ['Left', 'Right', 'Bilateral']
      }
      else if (this.bodyPartDetails.bodyprocedure == "Shoulder" || this.bodyPartDetails.bodyprocedure == "Sports" || this.bodyPartDetails.bodyprocedure == "Foot and Ankle" || this.bodyPartDetails.bodyprocedure == "Hand & Upper Extremities") {
        this.fracture = false
        this.bodyside = ['Left', 'Right']
      } else {
        this.fracture = false
        return this.bodyside = ['Left', 'Right', 'Bilateral']
      }
    }


  }

  getSide(side) {
    if(side == 'Left') {
      return this.userService.translateText('hospital_portal.body_part.left.label')
    } else if(side == 'Right') {
      return this.userService.translateText('hospital_portal.body_part.right.label')
    } else if(side == 'Bilateral') {
      return this.userService.translateText('hospital_portal.body_part.bilateral.label')
    }
  }
  clearBodyPart() {
    let self = this;
    self.bodyPartDetails.bodyPart = ''
    self.bodyPartDetails.bodySide = ''
  }
  getbundlepayortype() {
    this.patientService.getbundletype().subscribe(data => {
      this.payortype = data
    })
  }
  checked(value) {
    this.hiddenchecked = true;
    if (value) {
      this.showcross = true;
    }

  }
  dosclear() {
    let self = this;
    self.bodyPartDetails.dos = ''
    this.bodyPartDetails.merge = false
    this.modalRef.hide()
  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }

  }
  checkempty(id) {
    var d = new Date(id);
    var timeDiff = Math.ceil(d.getTime() - this.dosMaxDate.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    ////console.log(id)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
    } else if (id != '' && id != null) {
      this.showinvaild = false
    }
    if (diffDays > 0) {

      this.bodyPartDetails.dos = '';
      this.toast.error(this.userService.translateText('hospital_portal.disp_messages.invalid_date.error'), '', {
        timeOut: this.timealert
      })
      return;

    }
  }

  check6(id) {
    ////console.log(id)
    if (id == '' || id == null) {
      this.shospital6 = true
      ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital6 = false
      ////console.log("false")
    }

  }
  check7(id) {
    ////console.log(id)
    if (id == '' || id == null) {
      this.shospital7 = true
      ////console.log("true")
    } else if (id != '' && id != null) {
      this.shospital7 = false
      ////console.log("false")
    }

  }
  getdate(date) {
    if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.datepipe.transform(date, environment.dateForm);
    } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.datepipe.transform(date, 'dd/MM/yyyy');
    }
  }
  getdatetime(date) {
    if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
    } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
    }
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }

  changeStringFormat2(dateString) {
    var dStartDate
    var changedFormat
    var splitDate1, day1, month1, year1
    var date: any = new Date(dateString)
    if (date != '' && date != null && date != 'Invalid Date') {
      if (this.CurrentUser.item.language == 'en_uk') {
        splitDate1 = dateString.split('/');
        day1 = splitDate1[0];
        month1 = splitDate1[1];
        year1 = splitDate1[2];
        dStartDate = month1 + "/" + day1 + "/" + year1;
        changedFormat = this.datepipe.transform(dStartDate, 'yyyy-MM-dd');
        return changedFormat;
      }
      changedFormat = this.datepipe.transform(dateString, 'yyyy-MM-dd');
    } else if (date == 'Invalid Date' && dateString != 'Invalid Date' && dateString != undefined) {
      if (this.CurrentUser.item.language == 'en_uk') {
        splitDate1 = dateString.split('/');
        day1 = splitDate1[0];
        month1 = splitDate1[1];
        year1 = splitDate1[2];
        dStartDate = month1 + "/" + day1 + "/" + year1;
      }
      changedFormat = this.datepipe.transform(dStartDate, 'yyyy-MM-dd');
    }
    return changedFormat
  }


  //Other SOS Popup
  patdisqualifi: any = {}
  reason: any;
  otherHospId: any = 0;
  othersos(hospitalId, sostemplate) {
    this.patdisqualifi = {}
    this.otherHospId = _.filter(this.hospitalList, (n) => {
      return (n.name.match('Other'))
    })
    this.otherHospId = this.otherHospId.map(function (el) { return el.hospitalId; });
    if (hospitalId == this.otherHospId) {
      this.reasonstage()
      this.patdisqualifi.reasonId = ''
      this.modalRef = this.modalService.show(sostemplate, { class: 'modal-lg', backdrop: "static" });
      this.movable()
    }
  }
  reasonstage() {
    this.patientService
      .getReasonCodeDetailsList()
      .subscribe(
        data => {
          this.reason = data;
        }

      );
  }
  close() {
    this.bodyPartDetails.hospitalId = ''
    this.modalRef.hide();
  }
  disqualifipatient(data) {
    if (data) {
      if (this.patdisqualifi) {
        let disqualifi = {
          othersos: this.patdisqualifi.sos,
          notes: this.patdisqualifi.notes ? this.patdisqualifi.notes : '',
          reasonId: this.patdisqualifi.reasonId,
          other: this.patdisqualifi.other ? this.patdisqualifi.other : ''
        }
        this.bodyPartDetails.disqualifi = disqualifi
        this.modalRef.hide();
      }
    }
  }

  getClientType() {
    if (this.clienttype && (this.clienttype.search("CJR") != -1 || this.clienttype.search("PRO_ONLY") != -1))
      return 'CJR'
    else if (this.clienttype && (this.clienttype.search("MAKO") != -1 || this.clienttype.search("NON_GROUP") != -1))
      return 'MAKO'
    else
      return false
  }

}